import { render, staticRenderFns } from "./SelectRoleAssignmentArtist.vue?vue&type=template&id=70677326&"
import script from "./SelectRoleAssignmentArtist.vue?vue&type=script&lang=js&"
export * from "./SelectRoleAssignmentArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports